import { run, show, showPreferences } from "../services/cookieconsent.esm.js";

function cookies() {
	run({
		guiOptions: {
			consentModal: {
				layout: "box",
				position: "bottom right",
				equalWeightButtons: true,
				flipButtons: false,
			},
			settingsModal: {
				layout: "box",
				columnLayout: "1col",
			},
		},

		categories: {
			necessary: {
				readOnly: true,
			},
		},

		language: {
			default: "pl",
			translations: {
				pl: {
					consentModal: {
						title: "Dbamy o Twoją prywatność 🍪",
						description:
							"Strona <strong>Inewera Sp. z o.o.</strong> wykorzystuje niezbędne pliki cookie w celu zapewnienia jej prawidłowego działania. Pozostałe pliki cookie zostaną aktywowane wyłącznie po wyrażeniu przez Ciebie zgody.",
						acceptAllBtn: "Akceptuj wszystkie",
						acceptNecessaryBtn: "Odrzuć opcjonalne",
						showPreferencesBtn: "Ustawienia",
					},
					preferencesModal: {
						title: "Centrum preferencji",
						acceptAllBtn: "Akceptuj wszystkie",
						acceptNecessaryBtn: "Odrzuć wszystkie",
						savePreferencesBtn: "Zapisz zaznaczenie",
						closeIconLabel: "Zamknij",
						sections: [
							{
								title: "Wykorzystanie plików cookie",
								description:
									'Administratorem Twoich danych jest <strong>Inewera Sp. z o.o.</strong>. Używamy plików cookie, aby zapewnić podstawowe funkcje witryny i poprawić komfort użytkowania. Więcej informacji znajdziesz w naszej <a href="polityka.html" class="cc-link">Polityce Prywatności</a>.',
							},
							{
								title: "Czym są pliki cookies?",
								description:
									"Cookies to niewielkie pliki tekstowe zapisywane na urządzeniu użytkownika podczas korzystania ze strony internetowej..",
							},
							{
								title: "Niezbędne pliki cookie (Wymagane)",
								description:
									"Te pliki cookie są niezbędne do bezpiecznego i prawidłowego działania strony. Są one używane m.in. do obsługi formularza kontaktowego oraz zapamiętywania Twoich ustawień prywatności.",
								linkedCategory: "necessary",
							},
							{
								title: "Jakie cookies wykorzystujemy?",
								description:
									"<p>Strona może wykorzystywać:</p><ul><li>cookies niezbędne do prawidłowego działania strony,</li><li>cookies analityczne pomagające analizować ruch na stronie,</li><li>cookies funkcjonalne poprawiające komfort korzystania z serwisu.</li></ul>",
							},
							{
								title: "Prywatność danych w formularzach",
								description:
									"Twój numer telefonu oraz inne dane wpisane w formularzu kontaktowym są wykorzystywane wyłącznie do udzielenia odpowiedzi na Twoje zapytanie. <strong>Nie udostępniamy tych danych osobom trzecim</strong> ani nie wykorzystujemy ich do celów marketingowych bez Twojej wyraźnej zgody.",
							},
							{
								title: "Zarządzanie cookies",
								description:
									"Użytkownik może w każdej chwili zmienić ustawienia dotyczące plików cookies w swojej przeglądarce internetowej lub usunąć zapisane pliki cookies.Ograniczenie stosowania cookies może wpłynąć na niektóre funkcje dostępne na stronie internetowej.",
							},
							{
								title: "Dane kontaktowe",
								description:
									"W przypadku pytań dotyczących naszych zasad korzystania z plików cookie, prosimy o kontakt poprzez formularz na stronie, lub skontaktuj się z nami: <br><strong>Inewera Sp. z o.o. <br> e-mail: inewera.pl@gmail.com <br> <a href='https://www.inewera.pl'>www.inewera.pl</a></strong>.",
							},
						],
					},

					guiOptions: {
						consentModal: {
							layout: "cloud", // Форма хмаринки
							position: "bottom center", // Знизу по центру
							equalWeightButtons: true,
						},
						preferencesModal: {
							layout: "box", // Вікно налаштувань
							position: "right", // Відкривається справа
							equalWeightButtons: true,
						},
					},

					// Це налаштування дозволяє показувати кнопку виклику після згоди
					disablePageInteraction: false,

					// Щоб кнопка з'явилася автоматично (у v3 це часто робиться через CSS/HTML)
				},
			},
		},
	});

	document.addEventListener("click", (e) => {
		// Шукаємо, чи клікнули по самому щиту або по іконці всередині нього
		const btn = e.target.closest('[data-cc="show-preferences"]');

		if (btn) {
			e.preventDefault();
			showPreferences(); // Виклик вікна налаштувань
		}
	});
}
export default cookies;
